import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
// import { acceptOperationAction, rejectOperationAction } from '../../../../../store/slices/operationActionSlice';
import { fetchAllProjects } from '../../../../../store/slices/projectsSlice';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from 'react-redux';
// import { useSnackbar } from 'notistack';

const OPActionsPM = ({
    EmpEmail,
    handleProjectread,
    project,
    index,
    SetisLoading,
    SetShowprojectDetails,
    setselectedproject,
    setAcceptedProject,
    setOpenDetailsIdx,
    setServiceofuser,
    setAction,
    setselectedprojectid,
    setSelected,
    selected,
    employees,
    handlerefresh,
    showprojectDetails,
    isViewOnly = false
}) => {
    const dispatch = useDispatch();
    // const enqueueSnackbar = useSnackbar();
    const [openProbabilityIndex, setOpenProbabilityIndex] = useState(null);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });
    const currentEmployee = employees.find((emp) => emp.EmpEmail === EmpEmail);
    console.log("sfsgsdg", currentEmployee);
    const role = currentEmployee?.customRoles[0];
    console.log("sfsgsdgrole", role);

    const dropdownRefsProbability = useRef([]);
    const triggerRef = useRef(null);
    const dropdownPortalRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openProbabilityIndex === null) return;
            const triggerEl = dropdownRefsProbability.current[openProbabilityIndex];
            const portalEl = dropdownPortalRef.current;
            const clickedTrigger = triggerEl?.contains(event.target);
            const clickedPortal = portalEl?.contains(event.target);
            if (!clickedTrigger && !clickedPortal) {
                setOpenProbabilityIndex(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openProbabilityIndex]);

    // const handleAcceptProject = async (index, project) => {

    //     const email = EmpEmail

    //     const isUserAssigned = project.Assignedperson?.find(
    //         person => person.email === email // replace with your actual logged user email variable
    //     );
    //     if (isUserAssigned?.operationaction === "accept") {
    //         await handleProjectread(project)
    //         return
    //     }
    //     const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    //     const projectid = project?._id
    //     const userid = currentEmployee?._id
    //     try {
    //         await dispatch(acceptOperationAction({ projectid, userid }));
    //         await handleProjectread(project)
    //         if (project.AssignPerson.operationaction !== "accept") {
    //             enqueueSnackbar("Project Accepted Successfully", {
    //                 variant: "success",
    //             });
    //         }
    //         dispatch(fetchAllProjects());
    //     } catch (error) {
    //         console.error("Failed to reject Project:", error);
    //     } finally {
    //         dispatch(fetchAllProjects());
    //         handlerefresh()
    //     }
    // };

    // const handleRejectProject = async (index, project) => {
    //     const email = EmpEmail;
    //     const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    //     const projectid = project?._id
    //     const userid = currentEmployee?._id
    //     SetisLoading(true);
    //     try {
    //         await dispatch(rejectOperationAction({ projectid, userid }));
    //         enqueueSnackbar("Project Rejected Successfully", { variant: "success" });
    //         dispatch(fetchAllProjects());
    //     } catch (error) {
    //         console.error("Failed to reject Project:", error);
    //     } finally {
    //         SetShowprojectDetails(false);
    //         setOpenDetailsIdx(null);
    //         setOpenProbabilityIndex(null)
    //         SetisLoading(false);
    //         dispatch(fetchAllProjects());
    //         handlerefresh()
    //         setselectedprojectid("")
    //     }
    // };

    const person = project.Assignedperson.find(
        (p) => p.email === EmpEmail
    );
    return (
        <div>
            {
                role === "project manager" ? (
                    <div className="p-1">
                        <div
                            type="button"
                            onClick={() => {
                                // handleAcceptProject(index, project);
                                SetShowprojectDetails(true);
                                setselectedproject(project.ProjectName);
                                setselectedprojectid(project._id);
                                setServiceofuser(project.TypeService);
                                setAcceptedProject(project);
                                setOpenProbabilityIndex(openProbabilityIndex === null);
                                setOpenDetailsIdx(index);
                                dispatch(fetchAllProjects());
                                setSelected(!selected)
                            }}
                            className={`cursor-pointer
                drop btn min-w-32 max-w-36 
                relative flex items-center p-1 py-2  truncate break-words justify-center border border-gray-400 text-nowrap rounded-md
                  shadow-md text-sm overflow-hidden text-ellipsis bg-white "`}
                        >
                            View
                        </div>
                    </div>
                ) : (
                    <div className="relative bg-white w-full flex justify-center align-middle items-center">
                        <div
                            ref={(el) => (dropdownRefsProbability.current[index] = el)}
                            className="relative flex items-center "
                        >

                            <div
                                ref={(el) => {
                                    triggerRef.current = el;
                                    dropdownRefsProbability.current[index] = el;
                                }}
                                type="button"
                                onClick={() => {
                                    const person = project.Assignedperson.find(
                                        (p) => p.email === EmpEmail
                                    );
                                    if (person?.operationaction === "reject") return; // ⬅ block click
                                    const willOpen = openProbabilityIndex !== index;
                                    if (willOpen && triggerRef.current) {
                                        const rect = triggerRef.current.getBoundingClientRect();
                                        const spaceBelow = window.innerHeight - rect.bottom;
                                        const dropdownHeight = 60;
                                        const top = spaceBelow >= dropdownHeight ? rect.bottom + 2 : rect.top - dropdownHeight - 2;
                                        setDropdownPosition({
                                            top,
                                            left: rect.left,
                                            width: Math.max(rect.width, 120),
                                        });
                                    }
                                    setOpenProbabilityIndex(openProbabilityIndex === index ? null : index);
                                }}
                                className={`${person?.operationaction === "reject" ? "cursor-not-allowed" : "cursor-pointer"} 
                drop btn min-w-32 max-w-36 
                relative flex items-center p-1 py-2  truncate break-words justify-between border border-gray-400 text-nowrap rounded-md
                  shadow-md text-sm overflow-hidden text-ellipsis bg-white "`}
                            >
                                <span className="w-full text-xs truncate break-words">
                                    {(() => {
                                        const person = project.Assignedperson.find(
                                            (p) => p.email === EmpEmail
                                        );
                                        if (person?.operationaction === "reject") return "Rejected";
                                        if (person?.manageraction === "reassign") return "Reassign";
                                        if (person?.manageraction === "review") return "Review";
                                        if (person?.manageraction === "complete" && person?.taskStatus === "submit") return "Completed";
                                        if (person?.operationaction === "accept") return "Accepted";

                                        return "Select Option";
                                    })()}
                                </span>

                                <ExpandMoreIcon
                                    className="absolute right-0 text-gray-500 bg-white"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const person = project.Assignedperson.find(
                                            (p) => p.email === EmpEmail
                                        );
                                        if (person?.operationaction === "reject") return; // ⬅ block click
                                        const willOpen = openProbabilityIndex !== index;
                                        if (willOpen && triggerRef.current) {
                                            const rect = triggerRef.current.getBoundingClientRect();
                                            const spaceBelow = window.innerHeight - rect.bottom;
                                            const dropdownHeight = 60;
                                            const top = spaceBelow >= dropdownHeight ? rect.bottom + 2 : rect.top - dropdownHeight - 2;
                                            setDropdownPosition({
                                                top,
                                                left: rect.left,
                                                width: Math.max(rect.width, 120),
                                            });
                                        }
                                        setOpenProbabilityIndex(openProbabilityIndex === index ? null : index);
                                    }}
                                />
                            </div>

                            {openProbabilityIndex === index && ReactDOM.createPortal(
                                <div
                                    ref={dropdownPortalRef}
                                    className="dropdown fixed p-1 z-[9999] bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                    style={{
                                        top: dropdownPosition.top,
                                        left: dropdownPosition.left,
                                        width: dropdownPosition.width,
                                        minWidth: '8rem',
                                    }}
                                >
                                    {(() => {
                                        const action = project.Assignedperson.find(
                                            (person) => person.email === EmpEmail
                                        )?.operationaction;
                                        if (action === "reject") return null;
                                        return (
                                            <div
                                                className="p-1 cursor-pointer hover:bg-gray-100"
                                                onClick={() => {
                                                    SetShowprojectDetails(!showprojectDetails);
                                                    setselectedproject(project.ProjectName);
                                                    setselectedprojectid(prev => prev === project._id ? null : project._id);
                                                    setServiceofuser(project.TypeService);
                                                    setAcceptedProject(project);
                                                    setOpenProbabilityIndex(null);
                                                    setOpenDetailsIdx(index);
                                                    dispatch(fetchAllProjects());
                                                    setSelected(!selected);
                                                }}
                                            >
                                                View
                                            </div>
                                        );
                                    })()}
                                </div>,
                                document.body
                            )}
                        </div>
                        <div className="absolute right-1">
                            {project.Assignedperson?.[0]?.taskStatus === "Submit" && (
                                <div>✅</div>
                            )}
                        </div>
                    </div >
                )}

        </div >
    )
}

export default OPActionsPM